/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leveling_Perm_Use_Application_Commands_HintInputs */



/**
* | output |
* | --- |
* | "Allows members to use commands from applications, including slash commands and context menu commands." |
*
* @param {Leveling_Perm_Use_Application_Commands_HintInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_perm_use_application_commands_hint = /** @type {((inputs?: Leveling_Perm_Use_Application_Commands_HintInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Perm_Use_Application_Commands_HintInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Позволяет участникам использовать команды приложений, включая слэш-команды и команды контекстного меню.")
	return /** @type {LocalizedString} */ ("Allows members to use commands from applications, including slash commands and context menu commands.")
});